import { Component, Host, Prop, h } from '@stencil/core';
import { Icon, RedirectLink } from './rcm-secondary-nav-item.types';
import { Multilink, Target } from '../types/link.types';

@Component({
  tag: 'rcm-secondary-nav-item',
  styleUrl: 'rcm-secondary-nav-item.scss',
  shadow: true,
})
export class RcmSecondaryNavItem {
  @Prop() link_text: string;

  @Prop() icon: Icon;

  @Prop() redirect_link: RedirectLink;

  render() {
    const link: Multilink = {
      src: this.redirect_link?.cached_url,
      target: this.redirect_link?.target as Target,
    };
    return (
      <Host>
        {link.src && (
          <rcm-wrapper-link link={link} trackingLinkText={this.link_text} parentComponent="rcm-navigation">
            <div class="button">
              {this.icon?.filename && (
                <div class="button__icon">
                  <img src={this.icon.filename} alt={this.icon.alt} />
                </div>
              )}
              <div class="button__text">{this.link_text}</div>
            </div>
          </rcm-wrapper-link>
        )}
      </Host>
    );
  }
}
